export function createPageUrl(pageName) {
  const mapping = {
    Home: "/",
    Treatments: "/behandlingar",        
    Pictures: "/bilder",                  
    Staff: "/personal",                 
    AboutUs: "/om-oss",                 
  };
  return mapping[pageName] || "/";
}